import { getModelsApi } from "@/apis/model";
import { GetApiClient } from "@/utils/api-client";

export class ModelUsecase {
  static models(apiClient: GetApiClient) {
    return getModelsApi(apiClient);
  }
}
